// Egne ordre (source 'carrier') utføres av sjåføren med de samme skjermene som markedsplassen,
// men uten bestiller: ingen vektavviksgodkjenning og ingen bekreftelse fra bestiller.
export const isCarrierOrder = (order) => order?.source === 'carrier';

// Egne ordre fullføres av sjåføren selv. Markedsplass-ordre venter på bestillerens bekreftelse.
export const deliveryStatusFor = (order) => (isCarrierOrder(order) ? 'completed' : 'delivered_pending');

// Vektavvik må godkjennes av bestilleren, så flyten gjelder bare markedsplassen.
export const usesWeightDeviationFlow = (order) => !isCarrierOrder(order);

// Vektavvik (godkjenning fra bestiller) gjelder bare markedsplassen, og bare over minstevekten.
// Timeoppdrag betales per time og har ingen prisjustering etter vekt; mangler bestilt mengde, finnes det intet å avvike fra.
export function hasWeightDeviation(order, tons, { thresholdPct, minWeightTons }) {
  if (!usesWeightDeviationFlow(order)) return false;
  if (order.hourly) return false;
  if (!(tons > 0) || !order.estimatedTons) return false;
  if (order.estimatedTons < minWeightTons) return false;
  return Math.abs(tons - order.estimatedTons) / order.estimatedTons > thresholdPct / 100;
}

// Posisjonsdeling: samtykket sier at posisjonen bare deles med bestilleren. Egne ordre har
// ingen bestiller, så posisjon skrives ikke for dem (frem til sporing for firmaet er på plass).
const LOCATION_SHARED_STATUSES = ['matched', 'in_progress'];
export const shouldShareLocation = (order, canShare) =>
  !!canShare && !!order && !isCarrierOrder(order) && LOCATION_SHARED_STATUSES.includes(order.status);

// Egne ordre har ingen avtalt pris mellom sjåfør og bestiller, så den skal ikke vises i tidslinjen.
export const withoutAgreedPrice = (order) => (isCarrierOrder(order) ? { ...order, agreedPrice: undefined } : order);
